import tag from 'blacklist-tag';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { alignItems, color, flexDirection, flexWrap, justifyContent, maxWidth, minWidth, space } from 'styled-system';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { ThemeInterface } from '../../theme/ThemeInterface';

type TabsProps = StyledSystemProps & {
  color?: string;
  tabRowHeight?: string;
  tabDirection?: 'row' | 'column';
  tabs: Array<{ to: string; title: string }>;
  renderTabs?: () => Array<{ to: string; title: string }>;
};

const TabContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  padding: 0 20px;
  flex-wrap: wrap;
  flex-direction: row;
  box-sizing: border-box;
  background-color: ${(props: TabsProps) => String(props.bg)};
  box-shadow: 0 4px 4px -4px rgba(50, 50, 93, 0.3);
`;

const CleanTab = tag(NavLink as any, ['justifyContent', 'alignItems', 'maxWidth', 'renderTabs']);

const Tab = styled(CleanTab)`
  flex: 1;
  ${space};
  ${color};
  ${flexWrap};
  ${minWidth};
  ${maxWidth};
  ${alignItems};
  ${flexDirection};
  ${justifyContent};
  display: flex;
  position: relative;
  text-decoration: none;
  &.active-tab:after {
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    height: 3px;
    position: absolute;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    background-color: ${(props: ThemeInterface) => props.theme.colors.primary};
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const Tabs: React.FC<TabsProps> = props => {
  const tabs = props.renderTabs ? props.renderTabs() : props.tabs;
  return (
    <TabContainer {...props}>
      {tabs.map(tab => (
        <Tab to={tab.to} {...props} key={tab.title}>
          {tab.title}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default Tabs;

Tabs.defaultProps = {
  tabs: [],
  bg: 'white',
  color: 'primary',
  maxWidth: '200px',
  alignItems: 'center',
  justifyContent: 'center',
};
